import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=86955194&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=86955194&prod&lang=scss&scoped=true"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=86955194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86955194",
  null
  
)

export default component.exports